import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import Avatar from 'components/Avatar/Avatar';
import PropTypes from 'prop-types';

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper5,
  '&.Mui-selected': {
    borderColor: theme.palette.action.selected,
  },
}));

const DescriptiveButton = ({
  title,
  description,
  icon,
  onClick,
  selected,
  ...rest
}) => {
  return (
    <StyledListItemButton
      alignItems="flex-start"
      onClick={onClick}
      selected={selected}
      {...rest}
    >
      <ListItemAvatar>
        <Avatar
          size="large"
          sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}
        >
          {icon}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={description}
        slotProps={{
          primary: {
            variant: 'h5',
            fontWeight: 600,
          },
          secondary: {},
        }}
      />
    </StyledListItemButton>
  );
};

DescriptiveButton.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.element,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

export default DescriptiveButton;
